/**
 * PARTNERS_CURATED — /company §9 "Supported & Trusted By" grid.
 *
 * 18 entries, sourced live from frac.io on 2026-02-18, then filtered per
 * client instructions:
 *   - Removed: The Peak, CAI Partners, Diamond Alpha (internal group
 *     entity), Ghostbone Studios.
 *   - Truncated at Octopus Network. Two remaining source entries held
 *     for the next batch — see /app/memory/partners_pending_batch2.md.
 *
 * URLs supplied by client. Each entry pairs 1:1 with a URL — the visual
 * order below matches the live frac.io order minus the four removals.
 * Logos are self-hosted under /public/partners/.
 */

export const PARTNERS_CURATED = [
  {
    name: "MDEC (Malaysia Digital Status)",
    slug: "mdec",
    logo: "/partners/mdec.png",
    url:
      "https://www.linkedin.com/posts/frac-tional_frac-malaysia-asset-activity-7234773074410135552-Cjdi",
  },
  {
    name: "Traxx",
    slug: "traxx",
    logo: "/partners/traxx.png",
    url:
      "https://www.linkedin.com/posts/frac-tional_frac-traxx-luxury-activity-7226882273453690880-H4os",
  },
  {
    name: "Masverse",
    slug: "masverse",
    logo: "/partners/masverse.svg",
    url: "https://www.masverse.com/",
  },
  {
    name: "MasChain",
    slug: "maschain",
    logo: "/partners/maschain.png",
    url: "https://www.maschain.com/",
  },
  {
    name: "VeChain",
    slug: "vechain",
    logo: "/partners/vechain.svg",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7075062932719456256",
  },
  {
    name: "XDC Network",
    slug: "xdc-network",
    logo: "/partners/xdc-network.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7228957773600866305",
  },
  {
    name: "GamBit Custody",
    slug: "gambit-custody",
    logo: "/partners/gambit-custody.png",
    url:
      "https://focusmalaysia.my/frac-and-gambit-ink-strategic-collaboration-mou-to-empower-the-future-of-asset-management/",
  },
  {
    name: "Crypto.com",
    slug: "crypto-com",
    logo: "/partners/crypto-com.png",
    url:
      "https://www.linkedin.com/posts/frac-tional_as-an-asia-focused-project-frac-is-pleased-activity-7117071469079113729-oQLY",
  },
  {
    name: "Helium Network",
    slug: "helium",
    logo: "/partners/helium.svg",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7094225731001462784",
  },
  {
    name: "Quaich Bar",
    slug: "quaich-bar",
    logo: "/partners/quaich-bar.jpeg",
    url: "https://quaichbar.com.sg/",
  },
  {
    name: "Regal Rare",
    slug: "regal-rare",
    logo: "/partners/regal-rare.jpeg",
    url: "https://www.regalrare.com/",
  },
  {
    name: "Academic Labs",
    slug: "academic-labs",
    logo: "/partners/academic-labs.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7082340874805723136",
  },
  {
    name: "Diamond Labs",
    slug: "diamond-labs",
    logo: "/partners/diamond-labs.png",
    url: "https://xdc.diamondlabs.io/igo",
  },
  {
    name: "SBF (Singapore Business Federation)",
    slug: "sbf",
    logo: "/partners/sbf.svg",
    url: "https://www.sbf.org.sg/",
  },
  {
    name: "Aegis Communications",
    slug: "aegis",
    logo: "/partners/aegis.svg",
    url: "https://www.linkedin.com/company/aegiscommunications/about/",
  },
  {
    name: "Hinterland",
    slug: "hinterland",
    logo: "/partners/hinterland.svg",
    url: "https://hinterland.sg/Frac",
  },
  {
    name: "MXC Foundation",
    slug: "mxc",
    logo: "/partners/mxc.svg",
    url:
      "https://twitter.com/MXCfoundation/status/1605879627167277056?s=20",
  },
  {
    name: "Octopus Network",
    slug: "octopus-network",
    logo: "/partners/octopus-network.svg",
    url: "https://forum.oct.network/t/appchain-candidate-frac/106",
  },

  // -------------------------------------------------------------------------
  // Batch 2 — added 2026-02-18. Continues from Octopus Network. 25 tiles.
  // Client's URL list had 26 items (Option 1 alignment); source has only
  // 25 remaining partners after S24, so the last URL slot has no source
  // counterpart and was dropped (documented in partners_pending_batch2.md).
  // Positions 11 (QORRA) and 15 (HICOOL) render without hyperlinks per
  // client Option 1 — their originally-listed URLs are logged in
  // /app/memory/partners_batch2_discarded_urls.md.
  // -------------------------------------------------------------------------
  {
    name: "Tribe Accelerator",
    slug: "tribe-accelerator",
    logo: "/partners/tribe-accelerator.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7042434634046992384",
  },
  {
    name: "BR-Group",
    slug: "br-group",
    logo: "/partners/br-group.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7054725533498032128",
  },
  {
    name: "Accelerator Cohort Winter 2022",
    slug: "winter-2022",
    logo: "/partners/winter-2022.png",
    url: "https://www.youtube.com/watch?t=140&v=xY1iGWVDk1s&feature=youtu.be",
  },
  {
    name: "Wakweli",
    slug: "wakweli",
    logo: "/partners/wakweli.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7067082532260827137",
  },
  {
    name: "NFT Moon Metaverse",
    slug: "nft-moon",
    logo: "/partners/nft-moon.png",
    url:
      "https://www.linkedin.com/posts/nft-moon-metaverse_frac-activity-7019945842706956288-AiXY",
  },
  {
    name: "NFT Bazl",
    slug: "nft-bazl",
    logo: "/partners/nft-bazl.png",
    url: "https://twitter.com/nftbazl/status/1623830726146760706?s=20",
  },
  {
    name: "Sharky",
    slug: "sharky",
    logo: "/partners/sharky.png",
    url: "https://x.com/SharkyFi/status/1821096278467719651",
  },
  {
    name: "Vortex DAO",
    slug: "vortex-dao",
    logo: "/partners/vortex-dao.png",
    url: "https://twitter.com/VortexDAO/status/1626862075543961600?s=20",
  },
  {
    name: "Nibiaa",
    slug: "nibiaa",
    logo: "/partners/nibiaa.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7034425326059294720",
  },
  {
    name: "HashCase",
    slug: "hashcase",
    logo: "/partners/hashcase.png",
    url: "https://twitter.com/hash_case/status/1646517000964038658?s=20",
  },
  // Position 11 — QORRA (no hyperlink per client Option 1)
  {
    name: "QORRA",
    slug: "qorra",
    logo: "/partners/qorra.png",
    url: null,
  },
  {
    name: "Partner (unreadable — client to identify)",
    slug: "partner-s36",
    logo: "/partners/partner-s36.png",
    url:
      "https://www.linkedin.com/posts/frac-tional_frac-activity-7050316393065435136-QNpY",
  },
  {
    name: "Hatch Web3 Accelerator (Hedera S2)",
    slug: "hatch-hedera",
    logo: "/partners/hatch-hedera.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7067137376510251008",
  },
  {
    name: "Capx",
    slug: "capx",
    logo: "/partners/capx.png",
    url: "https://twitter.com/Frac_tional/status/1656600154672078854?s=20",
  },
  // Position 15 — HICOOL (no hyperlink per client Option 1)
  {
    name: "HICOOL",
    slug: "hicool",
    logo: "/partners/hicool.png",
    url: null,
  },
  {
    name: "Partner (unreadable — client to identify)",
    slug: "partner-s40",
    logo: "/partners/partner-s40.png",
    url: "https://twitter.com/Frac_tional/status/1660586411999854593?s=20",
  },
  {
    name: "Koment",
    slug: "koment",
    logo: "/partners/koment.png",
    url: "https://twitter.com/Frac_tional/status/1658774489461555201?s=20",
  },
  {
    name: "Parcel",
    slug: "parcel",
    logo: "/partners/parcel.png",
    url: "https://twitter.com/Frac_tional/status/1676531492292362241?s=20",
  },
  {
    name: "MajinX",
    slug: "majinx",
    logo: "/partners/majinx.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7082340874805723136",
  },
  {
    name: "8SIAN",
    slug: "8sian",
    logo: "/partners/8sian.png",
    url: "https://twitter.com/Frac_tional/status/1684836220143026176?s=20",
  },
  {
    name: "OHTC",
    slug: "ohtc",
    logo: "/partners/ohtc.png",
    url:
      "https://www.linkedin.com/posts/frac-tional_asset-tokenisation-activity-7107645427105091584-A600",
  },
  {
    name: "Dexify",
    slug: "dexify",
    logo: "/partners/dexify.png",
    url: "https://x.com/Frac_tional/status/1704405557463957813?s=20",
  },
  {
    name: "StraitsX",
    slug: "straitsx",
    logo: "/partners/straitsx.png",
    url: "https://x.com/Frac_tional/status/1727937043609878591?s=20",
  },
  {
    name: "NoRamp",
    slug: "noramp",
    logo: "/partners/noramp.png",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7183437310087069696",
  },
  {
    name: "Laysion Network",
    slug: "laysion",
    logo: "/partners/laysion.png",
    url: "https://x.com/laysionnetwork/status/1812033705009119417",
  },
];
